var log = require('./log').log;
exports.first = function () {
  log('1');
}



//////////////////
// WEBPACK FOOTER
// ./first.js
// module id = 0
// module chunks = 0